import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f609b2c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "memberDialog_newMemberActivity_box" }
const _hoisted_2 = {
  class: "newMemberInfo abs flex-col-aisrt",
  style: {"top":"55px","left":"40px","text-align":"left"}
}
const _hoisted_3 = { class: "newMemberInfoSpan" }
const _hoisted_4 = {
  key: 0,
  class: "flex-cen-ter"
}
const _hoisted_5 = { class: "newMemberInfoSpan" }
const _hoisted_6 = { class: "numBack flex-cen-ter" }
const _hoisted_7 = {
  key: 0,
  class: "symbol"
}
const _hoisted_8 = { class: "newMemberInfoSpan" }
const _hoisted_9 = {
  key: 1,
  class: "flex-cen-ter"
}
const _hoisted_10 = { class: "newMemberInfoSpan" }
const _hoisted_11 = {
  key: 0,
  class: "newMemberInfoSpan"
}
const _hoisted_12 = { class: "numBack flex-cen-ter" }
const _hoisted_13 = {
  key: 0,
  class: "symbol"
}
const _hoisted_14 = {
  key: 1,
  class: "newMemberInfoSpan"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newMemberBtn abs cursor-pt" }, null, -1))
const _hoisted_17 = { class: "payForMember flex-cen-ter" }

import { computed } from 'vue'
import { t } from '@/plugins/i18n'
import { useRtfix, useSite, isJA, isKO } from '@/store'
import { useStore } from 'vuex'
import { Site } from '@/common/const'
import { getCurrentMonetaryUnit, getActivePriceByStation } from '@/util/useYan'


export default /*#__PURE__*/_defineComponent({
  props: ['visible'],
  setup(__props) {

const props = __props
const store = useStore()
const loginText = store.getters.isSub ? '查看会员' : '开通会员'

const onlyOpenSpecail = computed(() => store.getters.onlyOpenSpecail)
// const emit = defineEmits(['update:visible'])
const memberClose = require('@/assets/image/icon/member/member-close-bold.png')
const newMemberActivity = computed(() => store.state.status.newMemberActivity.id ? store.state.status.newMemberActivity : false)

const countryCurrency = getCurrentMonetaryUnit() // 站点的货币符号

// 没有活动的提示
const getNoVipTipImage = () => {
  if (isJA()) {
    return 'https://static-jp.theckb.com/static-asset/client/vip/vip_jump.png'
  } else if (isKO()) {
    return 'https://static-s.theckb.com/BusinessMarket/member/vip_pop_ko2.png'
  } else {
    return 'https://theckbstest-oss.theckbs.com/BusinessMarket/member/vip_jump_UkStation.png'
  }
}

// 有活动的提示
const getFirstJoinVipTipImage = () => {
  if (isJA()) {
    return 'https://static-s.theckb.com/BusinessMarket/member/new_member_pop_up_background_long@2x.png'
  } else if (isKO()) {
    return 'https://static-s.theckb.com/BusinessMarket/member/vip_pop_ko3.png'
  } else {
    return 'https://static-s.theckb.com/BusinessMarket/member/vip_pop_background_long_en.png'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: props.visible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((props.visible) = $event)),
      "show-close": false,
      width: _unref(newMemberActivity) && !_unref(onlyOpenSpecail) ? '500px' : '400px',
      "custom-class": `memberDialog ${_unref(newMemberActivity) && !_unref(onlyOpenSpecail) ? 'memberDialog_newMemberActivity' : ''}`,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    }, {
      default: _withCtx(() => [
        (_unref(newMemberActivity) && !_unref(onlyOpenSpecail))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["newMember", _unref(useSite)()])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('首次加入会员')), 1),
                (_unref(isJA)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('尊享首月')), 1),
                      _createElementVNode("div", _hoisted_6, [
                        _createTextVNode(_toDisplayString(_unref(newMemberActivity).specialPrice), 1),
                        (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "％"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(newMemberActivity).hasSpecialTrialDiscount? _unref(countryCurrency) : 'OFF'), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('尊享首月')), 1),
                      (_unref(newMemberActivity).hasSpecialTrialDiscount)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, " " + _toDisplayString(_unref(countryCurrency)) + " ", 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_12, [
                        _createTextVNode(_toDisplayString(_unref(newMemberActivity).specialPrice), 1),
                        (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "％"))
                          : _createCommentVNode("", true)
                      ]),
                      (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString('OFF')))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              _createElementVNode("img", {
                class: "abs",
                src: getFirstJoinVipTipImage(),
                alt: ""
              }, null, 8, _hoisted_15),
              _createVNode(_component_router_link, {
                to: _unref(useRtfix)('VipLevel'),
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["to"])
            ], 2))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_el_image, {
                src: getNoVipTipImage(),
                class: _normalizeClass(["memberBack", _unref(useSite)()])
              }, null, 8, ["src", "class"]),
              _createVNode(_component_router_link, {
                to: _unref(useRtfix)('VipLevel'),
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)(_unref(loginText))), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ], 64)),
        _createElementVNode("div", {
          class: "closeBtn flex-cen-ter",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).commit('status/memberDialog', false)))
        }, [
          _createVNode(_component_el_image, { src: _unref(memberClose) }, null, 8, ["src"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "width", "custom-class"])
  ]))
}
}

})